import { AxiosPromise } from 'axios';
import { ContactTag } from '../../types/ContactTag';
import { libApiInstance } from '../axios';

export function requestUserTags(signal?: AbortSignal): AxiosPromise<ContactTag[]> {
    return libApiInstance.get(`/clients/tags`, {
        signal,
    });
}
